import { render, staticRenderFns } from "./ChargeRecordInternalExpand.vue?vue&type=template&id=588f7e62"
import script from "./ChargeRecordInternalExpand.vue?vue&type=script&lang=js"
export * from "./ChargeRecordInternalExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports